var map = {
	"./add.svg": "76a4",
	"./add_big.svg": "f754",
	"./applet.svg": "3783",
	"./applets.svg": "dbce",
	"./arrow.svg": "21e2",
	"./arrow_down.svg": "4b1a",
	"./arrow_dropdown.svg": "5ce4",
	"./arrow_up.svg": "1ad6",
	"./attention_level1.svg": "08a1",
	"./attention_level2.svg": "8b91",
	"./attention_level3.svg": "073d",
	"./avatar.svg": "f2e9",
	"./back.svg": "7338",
	"./brand.svg": "11dd",
	"./call.svg": "01f2",
	"./call_in.svg": "b8b5",
	"./call_out.svg": "46bb",
	"./certificate.svg": "3f13",
	"./check.svg": "7bae",
	"./close.svg": "8b1b",
	"./code.svg": "100a",
	"./copy.svg": "8aac",
	"./delete.svg": "0d45",
	"./derived.svg": "1c88",
	"./derived_hover.svg": "a265",
	"./detail.svg": "ddc0",
	"./down.svg": "d8aa",
	"./download.svg": "f28e",
	"./draggable.svg": "ed6b",
	"./edit.svg": "daf0",
	"./error.svg": "28c3",
	"./export.svg": "1578",
	"./eye.svg": "7364",
	"./female.svg": "83b0",
	"./file.svg": "a147",
	"./gender-female.svg": "07af",
	"./gender-male.svg": "bb25",
	"./help.svg": "acc2",
	"./ic_help.svg": "bb94",
	"./ico_delete.svg": "79a0",
	"./ico_export.svg": "2e0b",
	"./ico_search.svg": "b527",
	"./ico_setting.svg": "ed2a",
	"./ico_transfer.svg": "fb9a",
	"./import.svg": "5d78",
	"./import1.svg": "8932",
	"./ivr-key.svg": "223a",
	"./ivr_empty.svg": "cc51",
	"./ivr_template.svg": "42f7",
	"./link.svg": "40a1",
	"./link2.svg": "d8ae",
	"./link3.svg": "0e16",
	"./male.svg": "8c6b",
	"./multi-done.svg": "e898",
	"./multi-handle.svg": "b24e",
	"./new.svg": "bdaf",
	"./new_zh_cn.svg": "b914",
	"./people.svg": "1a5b",
	"./phone.svg": "c3bb",
	"./public.svg": "79b4",
	"./qq.svg": "cd8f",
	"./qq_large.svg": "3df7",
	"./question.svg": "9872",
	"./refresh.svg": "53fa",
	"./remove.svg": "5088",
	"./reset.svg": "c680",
	"./right-arrow.svg": "c686",
	"./search.svg": "d103",
	"./seats.svg": "7df0",
	"./setting.svg": "5de8",
	"./suceed_large.svg": "653f",
	"./sync.svg": "9c0e",
	"./tick.svg": "812c",
	"./time_condition.svg": "1a18",
	"./tips.svg": "fc46",
	"./transfer_in.svg": "efe6",
	"./transfer_in_out.svg": "9d23",
	"./transfer_out.svg": "9268",
	"./up.svg": "5c5b",
	"./v-status-bar-guide.svg": "eda7",
	"./website.svg": "7824",
	"./wpa-qq.svg": "c51a",
	"./wpa-rule.svg": "c092",
	"./wpa-web.svg": "0c00"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0765";